import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import style from './GeotreeInfoPanel.style';
import { FMContainer } from 'atoms';

let EmptyPanel = (props: WithStyles) =>
    <FMContainer square className={props.classes.panel} />;

export default withStyles(style)(EmptyPanel);
